export default __webpack_public_path__ + "static/media/arrow.ffe11b41.svg";